import React from 'react';
import PropTypes from 'prop-types';
import { useIsMobile } from 'utils/hooks';
import Dialog from 'components/Ui/Dialog';
import styles from './styles.scss';

const PrimoLearnMoreDialog = ({ learnMore, open, isCloseIcon, onClose }) => {
  const isMobile = useIsMobile();

  return open ? (
    <Dialog
      fullScreen={isMobile}
      isAutoClose={false}
      isCloseIcon={isCloseIcon}
      open={open}
      onClose={onClose}
      customStyle="v2"
      noPaddingContent
      aria-labelledby="dialog-title"
    >
      <div className={styles.container}>
        <div
          className={!isMobile ? styles.subContainer : styles.mobileContainer}
          onClick={onClose}
          onKeyDown={onClose}
          role="button"
          tabIndex="0"
        >
          <div className={styles.imageContainer}>
            <img
              src={`${learnMore.file.url}?fm=webp`}
              alt={learnMore.description}
            />
          </div>
        </div>
      </div>
    </Dialog>
  ) : null;
};

PrimoLearnMoreDialog.propTypes = {
  learnMore: PropTypes.object,
  open: PropTypes.bool,
  isCloseIcon: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
};

PrimoLearnMoreDialog.defaultProps = {
  isCloseIcon: true,
};

export default PrimoLearnMoreDialog;
